var _circle, _path, _path2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRaffle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 12,
    r: 6.5,
    stroke: "#BE69C3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 7C11.1231 7 12.2135 7.37811 13.0955 8.07341C13.9775 8.76872 14.5997 9.74071 14.8618 10.8328C15.124 11.9248 15.0109 13.0734 14.5407 14.0933C14.0705 15.1132 13.2706 15.9452 12.27 16.455C11.2693 16.9649 10.1261 17.123 9.02455 16.9039C7.92303 16.6848 6.92736 16.1012 6.19797 15.2472C5.46858 14.3932 5.04795 13.3185 5.00385 12.1963C4.95976 11.0741 5.29478 9.96968 5.95491 9.06108L10 12L10 7Z",
    fill: "#BE69C3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 4V3",
    stroke: "#BE69C3",
    strokeWidth: 3,
    strokeLinecap: "square"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 2,
    width: 4,
    height: 1,
    stroke: "#BE69C3",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRaffle);
export default __webpack_public_path__ + "static/media/raffle.3890f5e95fd20d2be1b93fcc3764c338.svg";
export { ForwardRef as ReactComponent };